import React from 'react';
import { useGuestAuthToken } from '../../utils/auth/useGuestAuthToken';
import { SocketContextPortalProvider } from '../../utils/socket/context/portalSocketContext';
import { SocketContextSentinelProvider } from '../../utils/socket/context/sentinelSocketContext';
import { IonContent, IonLoading } from '@ionic/react';

/**
 * Sets up web socket context for guest user.
 *
 * Adapted from AppSocketContext.
 *
 * @param children
 * @constructor
 */
export const AppSocketContextForGuest: React.FC = ({ children }) => {
  const authTokenResult = useGuestAuthToken();

  const effectiveAuthToken = React.useMemo(() => {
    if (!authTokenResult) return undefined;
    if (authTokenResult.isExpired === true) return undefined; // Wait for refresh
    return authTokenResult.value?.access.token;
  }, [authTokenResult]);

  if (effectiveAuthToken) {
    return (
      <SocketContextSentinelProvider token={effectiveAuthToken}>
        <SocketContextPortalProvider token={effectiveAuthToken}>{children}</SocketContextPortalProvider>
      </SocketContextSentinelProvider>
    );
  } else {
    return (
      <IonContent scrollX={false} scrollY={false}>
        <IonLoading isOpen={true} spinner="circles" />
      </IonContent>
    );
  }
};
